export enum AgreementTypeCd {
  PlDoc = 'PlDoc',
  Internal = 'Internal',
}
